export const getProtectedId = (uid: string, errorMessage: string) => (value: string) => {
  if (typeof value !== 'string' || value.trim().length === 0) {
    throw new Error(errorMessage);
  }

  return `${uid}-${value}`;
};
